<div
    id="identifyFeatures"
    class="widget container-fluid well"
    cdkDrag
    [cdkDragConstrainPosition]="computeDragPosition"
    #widget>
    <form id="identifyFeaturesForm">
        <div
            class="col-xs-12 widget-header"
            cdkDragHandle>
            <span class="heading-left">{{widgetConfig.header}}</span>
            <div class="pull-right btn-group btn-group-xs">
                <nlrp-help-link
                    [url]="helpLinkUrl"
                    [pageTitle]="helpPageTitle"></nlrp-help-link>

                <i
                    class="nlrp-icon nlrp-18"
                    [ngClass]="open ? 'nlrp-icon-up-chevron' : 'nlrp-icon-down-chevron'"
                    [title]="open ? widgetConfig.collapseTooltip : widgetConfig.expandTooltip"
                    (click)="toggleWidgetContentVisibility()">
                </i>

                <i
                    class="nlrp-icon nlrp-icon-close-cancel nlrp-18"
                    [title]="widgetConfig.closeTooltip"
                    (click)="onClose()"></i>
            </div>
        </div>
        <div class="widget-content">
            @if (rows) {
                <div>
                    <table class="table table-bordered">
                        <tbody>
                            @for (row of attrsList; track row) {
                                <tr
                                    [ngClass]="{'selected-feature': isSelected(row)}"
                                    (click)="onRowClick($event, row)">
                                    <td [innerHTML]="row.featureType | sanitizeResource: 'html'"></td>
                                    <td [innerHTML]="row.description | sanitizeResource: 'html'"></td>
                                    <td [innerHTML]="row.id | sanitizeResource: 'html'"></td>
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>
            }
        </div>
        <div class="col-xs-12 inline-bottom-buttons">
            <button
                type="button"
                id="clearIdentifiedFeaturesBtn"
                class="btn btn-default"
                title="Clear Identified Features"
                (click)="onClear()">
                Clear
            </button>
            <button
                type="button"
                id="closeIdentifiedFeatures"
                class="btn btn-default"
                title="Close Identified Features"
                (click)="onClose()">
                Close
            </button>
        </div>
    </form>
</div>
